import React from "react"
import { Alert, Typography } from "antd"

import { W0 } from "@components/constants"
import Markdown from "@components/Markdown"

const LABEL_DESCRIPTION = "Email {EMAIL} already taken by [{NAME}]({ACCOUNT_LINK})"


const renderInvestorExistsAlert = (accountsMapByEmail, investorEmail = "") => {
  if (!investorEmail) {
    return null
  }

  const email = investorEmail.toLowerCase().trim()
  const account = accountsMapByEmail[email]

  if (!account) {
    return null
  }

  const { id, investor = {} } = account

  const { givenName = "", familyName = "" } = investor
  const fullName = `${givenName} ${familyName}`

  const description = LABEL_DESCRIPTION
    .replace("{EMAIL}", email)
    .replace("{NAME}", fullName)
    .replace("{ACCOUNT_LINK}", `/backstage/investors/${id}`)

  const components = {
    p(props) {
      const { children } = props
      return (
        <Typography.Text>
          {children}
        </Typography.Text>
      )
    }
  }

  return (
    <Alert
      type="warning"
      style={{ marginTop: W0 }}
      message={<Markdown text={description} components={components} />}
    />
  )
}

export default renderInvestorExistsAlert
